import { RootState } from '@next/core-lib/app';
import { TableColumn, TableColumnTypes } from '@next/core-lib/table';

import {
  DeliveryColumnTypes,
  DeliveryLineWithDelivery,
  RawMaterialPercentages,
} from 'src/app/delivery-data/delivery-data.model';

import { DateRange } from '../../shared/models/date-range.model';

export interface GreenhouseModuleState extends RootState {
  greenhouseNoticeVisible: boolean;
}

const columnDefinitions = [
  { id: DeliveryColumnTypes.deliveryDate, type: TableColumnTypes.DATE },
  { id: DeliveryColumnTypes.allShipToIds, type: TableColumnTypes.STRING },
  { id: DeliveryColumnTypes.externalProductId, type: TableColumnTypes.STRING },
  { id: DeliveryColumnTypes.productTitle, type: TableColumnTypes.STRING },
  { id: DeliveryColumnTypes.klwArticleGroupName, type: TableColumnTypes.STRING },
  { id: DeliveryColumnTypes.unitQuantity, type: TableColumnTypes.NUMBER },
  { id: DeliveryColumnTypes.emissionFactorPercent00, type: TableColumnTypes.NUMBER },
  { id: DeliveryColumnTypes.emissionFactorPercent40, type: TableColumnTypes.NUMBER },
  { id: DeliveryColumnTypes.emissionFactorPercent80, type: TableColumnTypes.NUMBER },
  { id: DeliveryColumnTypes.co2Total, type: TableColumnTypes.NUMBER },
  { id: DeliveryColumnTypes.fossilExcludingPeatEmissions, type: TableColumnTypes.NUMBER },
  { id: DeliveryColumnTypes.fossilPeatEmissions, type: TableColumnTypes.NUMBER },
  { id: DeliveryColumnTypes.biogenic, type: TableColumnTypes.NUMBER },
  { id: DeliveryColumnTypes.landUseChange, type: TableColumnTypes.NUMBER },
  { id: DeliveryColumnTypes.europeanRawMaterialPercentage, type: TableColumnTypes.NUMBER },
  { id: DeliveryColumnTypes.circularRawMaterialPercentage, type: TableColumnTypes.NUMBER },
] as const satisfies readonly TableColumn[];

export type GreenhouseViewModel = Pick<
  DeliveryLineWithDelivery & RawMaterialPercentages,
  (typeof columnDefinitions)[number]['id'] | 'id' | 'deliveryId'
>;

export type GreenhouseExportRow = Omit<GreenhouseViewModel, 'allShipToIds'> & {
  allShipToIds: string;
};

export const greenhouseColumns: readonly (TableColumn & {
  id: (typeof columnDefinitions)[number]['id'];
})[] = columnDefinitions.map((column) => ({ digitsInfo: '1.0-2', ...column }));

export const displayColumns = greenhouseColumns.map((column) => column.id);

export interface GreenhouseDataFilters {
  locations: number[];
  search: string;
  dateRange: DateRange;
}
